import { DiscountType } from '@models/ropolo';
import { OrderingInitialState } from '@reducers/ordering/types';

export const removeDiscount = (state: OrderingInitialState): OrderingInitialState => ({
  ...state,
  pricingState: {
    ...state.pricingState,
    discountType: DiscountType.MONEY,
    discountAmount: 0,
  },
});
